module.exports = __webpack_public_path__ + "img/men.00a5dda2.svg";